// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero-module--hero--2qu-X","text":"Hero-module--text--1z9lT"};